import { StyledSectionContent } from "./styles";

function MyTechStack() {
  return (
    <StyledSectionContent name="stack">
      <h1>
        <span className="icon">{">"}</span>Tech Stack
      </h1>
      <ul>
        <li>
          <i class="devicon-html5-plain colored"></i>
        </li>
        <li>
          <i class="devicon-css3-plain colored"></i>
        </li>
        <li>
          <i class="devicon-javascript-plain colored"></i>
        </li>
        <li>
          <i class="devicon-react-original colored"></i>
        </li>
        <li>
          <i class="devicon-angularjs-plain colored"></i>
        </li>
        <li>
          <i class="devicon-git-plain colored"></i>
        </li>
        <li>
          <i class="devicon-redux-original colored"></i>
        </li>
        <li>
          <i class="devicon-nodejs-plain colored"></i>
        </li>
        <li>
          <i class="devicon-postgresql-plain colored"></i>
        </li>
        <li>
          <i class="devicon-docker-plain colored"></i>
        </li>
      </ul>
    </StyledSectionContent>
  );
}

export default MyTechStack;
